import { config } from "@repo/config";
import { ActiveSessionsBlock } from "@saas/settings/components/ActiveSessionsBlock";
import { PasskeysBlock } from "@saas/settings/components/PasskeysBlock";
import { PasswordSection } from "@saas/settings/components/PasswordSection";
import { SettingsPageIntro } from "@saas/settings/components/SettingsLayout";
import { TwoFactorBlock } from "@saas/settings/components/TwoFactorBlock";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getUserAccountsFn } from "~/server/auth";

const getSecurityDataFn = createServerFn({ method: "GET" }).handler(
	async () => {
		const accounts = await getUserAccountsFn();
		return {
			hasPassword:
				accounts?.some(
					(account) => account.providerId === "credential",
				) ?? false,
		};
	},
);

export const Route = createFileRoute("/_saas/app/_account/settings/security")({
	loader: () => getSecurityDataFn(),
	head: () => ({ meta: [{ title: `Security - ${config.appName}` }] }),
	component: SecuritySettingsPage,
});

function SecuritySettingsPage() {
	const { hasPassword } = Route.useLoaderData();

	return (
		<>
			<SettingsPageIntro title="Security" />
			{config.auth.enablePasswordLogin ? (
				<PasswordSection hasPassword={hasPassword} />
			) : null}
			{config.auth.enablePasskeys ? <PasskeysBlock /> : null}
			{config.auth.enableTwoFactor ? <TwoFactorBlock /> : null}
			<ActiveSessionsBlock />
		</>
	);
}
